export function AcknowledgeDeliveries(): string {
	return `/v1/me/chat-deliveries`;
}

export function AcknowledgePushDelivery(): string {
	return `/v1/chat-deliveries`;
}

export function AddReaction(organizationID: number, ID: number, messageID: number): string {
	return `/v1/organizations/${organizationID}/chat/${ID}/messages/${messageID}/reactions`;
}

export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/chat`;
}

export function CreateMessage(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/chat/${ID}/messages`;
}

export function CreateUser(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/chat/${ID}/users`;
}

export function Delete(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/chat/${ID}`;
}

export function DeleteMessage(organizationID: number, ID: number, messageID: number): string {
	return `/v1/organizations/${organizationID}/chat/${ID}/messages/${messageID}`;
}

export function DeleteUser(organizationID: number, ID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/chat/${ID}/users/${userID}`;
}

export function List(organizationID: number): string {
	return `/v1/organizations/${organizationID}/chat`;
}

export function ListMessageReceipts(organizationID: number, ID: number, messageID: number): string {
	return `/v1/organizations/${organizationID}/chat/${ID}/messages/${messageID}/receipts`;
}

export function ListMessageSeenBy(organizationID: number, ID: number, messageID: number): string {
	return `/v1/organizations/${organizationID}/chat/${ID}/messages/${messageID}/seen`;
}

export function ListMessages(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/chat/${ID}/messages`;
}

export function ListMonitored(accountID: number): string {
	return `/v1/accounts/${accountID}/monitored-chats`;
}

export function ListUsers(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/chat/${ID}/users`;
}

export function RemoveReaction(organizationID: number, ID: number, messageID: number, reactionID: number): string {
	return `/v1/organizations/${organizationID}/chat/${ID}/messages/${messageID}/reactions/${reactionID}`;
}

export function SendEvent(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/chat/${ID}/events`;
}

export function SetPollVotes(organizationID: number, ID: number, messageID: number): string {
	return `/v1/organizations/${organizationID}/chat/${ID}/messages/${messageID}/poll/votes`;
}

export function Show(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/chat/${ID}`;
}

export function ShowConversation(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/chat/${ID}/conversation`;
}

export function UnreadCount(): string {
	return `/v1/me/unread-chats-count`;
}

export function Update(organizationID: number, ID: number): string {
	return `/v1/organizations/${organizationID}/chat/${ID}`;
}

export function UpdateMessage(organizationID: number, ID: number, messageID: number): string {
	return `/v1/organizations/${organizationID}/chat/${ID}/messages/${messageID}`;
}

export function UpdateUser(organizationID: number, ID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/chat/${ID}/users/${userID}`;
}

